'use strict';

import UserData from 'Data/UserData';
import GenericTableData from './GenericTableData';

// User Role Module Event Bus. Handles all interactions with User Role.
let UserRoleData = GenericTableData.getTableDataBus('USER_ROLE', 'user_roles');

UserRoleData.createRoleRecord = (recordData) => {
  return UserRoleData.createRecord(recordData)
    .then((results) => {
      return results;
    })
    .then(() => {
      UserData.populateUsers();
    });
};

UserRoleData.deleteRoleRecord = (recordData) => {
  return UserRoleData.deleteRecordsWhere(recordData).then(() => {
    UserData.populateUsers();
  });
};

export default UserRoleData;
